import { uuid } from '../../../../_metronic/helpers';
import { Provider } from '../../../helpers/models';

/**
 * WST-808: `archived` controls whether a provider appears in provider-selection
 * UI. `deactivated` only controls login, so a deactivated-but-not-archived
 * provider is still selectable.
 *
 * `keepUuid` keeps the currently-selected provider visible even once archived —
 * otherwise a select would hold a value that is not among its options and render
 * blank.
 */
export const isProviderVisible = (provider: Provider, keepUuid?: uuid): boolean =>
  !provider.archived || (!!keepUuid && provider.uuid === keepUuid);

export const visibleProviders = (providers?: Provider[], keepUuid?: uuid): Provider[] =>
  (providers || []).filter((p) => isProviderVisible(p, keepUuid));
